export default "__VITE_ASSET__BwEPonvr__"